import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from 'js-cookie';

const initialState = {
  personalInfo: {},
  loading: false,
  error: null,
};

export const submitPersonalInfo = createAsyncThunk(
  'personalInfoFormData/submitPersonalInfo',
  async (userData, { rejectWithValue }) => {
    const token = Cookies.get('authToken');

    if (!token) {
      throw new Error('Token is missing');
    }

    try {
      const formData = new FormData();
      formData.append('email', userData.email || '');
      formData.append('firstName', userData.firstName || '');
      formData.append('lastName', userData.lastName || '');
      formData.append('country', userData.country || '');
      formData.append('stateProvince', userData.stateProvince || '');
      formData.append('city', userData.city || '');
      formData.append('personalDetails', userData.personalDetails || '');
      formData.append('phone', userData.phone || '');
      formData.append('createdBy', userData.createdBy || '');
      formData.append('accountType', userData.accountType || '');

      if (userData.profilePicture) {
        formData.append('profilePicture', userData.profilePicture);
      }

      const response = await axios.put(
        'https://sourceiq-login-dha8dahravh6eyet.eastus-01.azurewebsites.net/api/user/register/names',
        // "http://localhost:3004/api/user/register/names",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


const personalInfoFormDataSlice = createSlice({
  name: 'personalInfoFormData',
  initialState,
  reducers: {
    resetPersonalInfoFormData: () => initialState,

    savePersonalInfo: (state, action) => {
      state.personalInfo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitPersonalInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitPersonalInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.personalInfo = action.payload;
      })
      .addCase(submitPersonalInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});


export const { resetPersonalInfoFormData, savePersonalInfo } =
  personalInfoFormDataSlice.actions;

export const savePersonalInfoToStore = (personalInfo) => (dispatch) => {
  dispatch(savePersonalInfo(personalInfo));
};

export default personalInfoFormDataSlice.reducer;
